class GeBl11Tabs {
  constructor () {
    this.init()
  }

  init () {
    const containers = document.querySelectorAll('.c-grado_esp_bloque11__container')
    containers.forEach(container => {
      const itemsTabs = container.querySelectorAll('.c-grado_esp_bloque11__itemTab')
      const itemsTexts = container.querySelectorAll('.c-grado_esp_bloque11__itemText')

      itemsTabs.forEach(itemTab => {
        itemTab.addEventListener('click', e => {
          itemsTabs.forEach(tab => {
            tab.classList.remove('isActive')
          })
          e.currentTarget.classList.add('isActive')

          itemsTexts.forEach(itemText => {
            itemText.classList.remove('isActive')
            if (itemText.getAttribute('data-id') === itemTab.getAttribute('data-id')) {
              itemText.classList.add('isActive')
            }
          })
        })
      })
    })
  }
}

export default GeBl11Tabs
